export type SkillTypeOption = {
  id: string;
  label: string;
  description: string;
};

export const SKILL_TYPES: SkillTypeOption[] = [
  { id: "translation", label: "翻译助手", description: "Translate between languages" },
  { id: "code-review", label: "代码审查", description: "Review code for quality and bugs" },
  { id: "doc-gen", label: "文档生成", description: "Generate documentation from code" },
  { id: "data-analysis", label: "数据分析", description: "Analyze data and generate reports" },
  { id: "custom", label: "自定义", description: "Create a custom skill from scratch" },
];

function normalizeSkillName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\u4e00-\u9fff]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");
}

export function buildCreateSkillMessage(name: string, description: string, skillType: string): string {
  const typeDef = SKILL_TYPES.find((t) => t.id === skillType);
  const typeHint = typeDef && typeDef.id !== "custom" ? `\nSkill type hint: ${typeDef.label} (${typeDef.description})` : "";
  const normalized = normalizeSkillName(name);

  return [
    `Please use the skill-creator skill to create a new skill:`,
    `- Name: ${normalized}`,
    `- Description: ${description}`,
    typeHint,
    ``,
    `Create it directly in the default agent workspace skills directory. Do not ask for confirmation, just proceed with creating the skill.`,
  ]
    .filter(Boolean)
    .join("\n");
}
